import React from "react";
import { Route, Switch } from "react-router-dom";
import KlausurenMain from "../components/Klausuren/KlausurenMain";
import CompanyNew from "../newForms2/companies/CompanyNew";
import NewPassword from "../newForms2/users/NewPassword";
import UserForgotPassword from "../newForms2/users/UserForgotPassword";
import UserLogin from "../newForms2/users/UserLogin";
import UserPasswordInsertCodeAndPw from "../newForms2/users/UserPasswordInsertCodeAndPw";
import Impressum from "./AGB/Impressum";
import "./App.css";
import CompanyList from "./CompanyList";
import Home from "./Home";
import Logout from "./Logout";
import NotFound from "./NotFound";
import UserList from "./UserList";
import Datenschutz from './AGB/Datenschutz'

const Routes = () => {
  // console.log("inside Routes");
  return (
    <>
      <Switch>
        <Route exact path="/home">
          <Home />
        </Route>
        <Route exact path="/logout">
          <Logout />
        </Route>
        <Route exact path="/login">
          <UserLogin />
        </Route>
        <Route exact path="/users">
          <UserList />
        </Route>
        <Route exact path="/password/request">
          <UserForgotPassword />
        </Route>
        <Route exact path="/password/code">
          <UserPasswordInsertCodeAndPw />
        </Route>
        <Route exact path="/companies">
          <CompanyList />
        </Route>
        <Route exact path="/datenschutz">
          <Datenschutz/>
        </Route>        
        <Route exact path="/impressum">
          <Impressum />
        </Route>
        <Route exact path="/companies/new">
          <CompanyNew />
        </Route>
        
        <Route exact path="/klausuren">
          <KlausurenMain />
        </Route>
        <Route exact path="/">
          <Home />
        </Route>
        <Route exact path="/newpassword/:username/:code">
          <NewPassword />
        </Route>
        <Route path="/">
          <NotFound />
        </Route>
      </Switch>
    </>
  );
};

export default Routes;
